// extracted by mini-css-extract-plugin
module.exports = {"page":"ResetPasswordPage-module__page___1a7y3","content":"ResetPasswordPage-module__content___s8qmm"};